module.exports = __webpack_public_path__ + "img/yue.ae30dd30.png";